import Keycloak from 'keycloak-js';

let keycloakConfig = {
    //url: 'http://localhost:9080/realms/posconsole/protocol/openid-connect/auth',
    //url: 'http://localhost:9080/',
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: process.env.VUE_APP_KEYCLOAK_REALM,
    clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
    
    
};

let keycloak = new Keycloak(keycloakConfig);

export default keycloak;

